// JavaScript Document

// Scripts written by Jacob Bearce @ Weblinx, Inc.

document.addEventListener("DOMContentLoaded", () => {
    document.documentElement.classList.remove("no-javascript");
});
